<template lang="pug" src="./List.pug"></template>
<script>
import { mapActions } from 'vuex'
import {VMoney} from 'v-money'

export default {

    name: 'UGC',
    directives: { money: VMoney },
    data: () => ({
        money: {
            decimal: ',',
            thousands: '.',
            prefix: 'R$ ',
            precision: 2,
            masked: false /* doesn't work with directive */
        },
        videos: [],
        dialog: false,
        selectedVideo: null,
        giftDialog: false,
        giftValue: '',
        giftConfirm: false,
        isValid: false,
        cancelGiftDialog: false,
        giftToCancel: null,
        loadingRequestId: 0,
        filters: {
            isViewed: null,
            isFavorite: null,
            isUsed: null
        },
        viewedFilterItems: [
            { text: 'Todos', value: null },
            { text: 'Novos', value: false },
            { text: 'Visualizados', value: true }
        ],
        favoriteFilterItems: [
            { text: 'Todos', value: null },
            { text: 'Apenas favoritos', value: true },
            { text: 'Apenas não favoritos', value: false }
        ],
        usedFilterItems: [
            { text: 'Todos', value: null },
            { text: 'Já utilizados', value: true },
            { text: 'Não utilizados', value: false }
        ],
        headers: [
            { text: 'Evento', value: 'event' },
            { text: 'Vídeos', value: 'videos', sortable: false, align: 'center' },
            { text: 'Presenteado', value: 'hasBonusGift', sortable: false, align: 'center' },
            { text: 'Utilizado', value: 'isUsed', sortable: false, align: 'center' },
            { text: 'Favoritos', value: 'isFavorite', sortable: false, align: 'center' },
            { text: 'Presentear', value: 'gift', sortable: false, align: 'center' }
        ],
        rules: {
            required: v => !!String(v).trim() || 'Informe um valor',
            minValue: v => {
            const n = Number(String(v).replace(/[^\d]/g, '')) / 100
            return n >= 20 || 'Mínimo R$ 20,00'
            },
            mustConfirm: v => v || 'Confirme o envio'
        }
    }),
    computed: {
        groupedVideos () {
            const byEvent = {}

            ;(this.videos || [])
            .filter(video => this.matchesActiveFilters(video))
            .forEach(v => {
            const ev = v.event || { _id: 'sem-evento' }

            // garante chave única por evento
            const key = ev._id || 'sem-evento'

            if (!byEvent[key]) {
                byEvent[key] = {
                event: ev,   // guarda o objeto completo
                videos: []
                }
            }

            byEvent[key].videos.push(v)
            })

            // devolve [{ event: {…}, videos: [...] }, ...]
            return Object.values(byEvent)
        }
    },
    methods: {
        ...mapActions(['getUgcVideos', 'postGiftVideo', 'deleteGiftVideo', 'updateUgcVideo', 'updateUgcVideoSilent']),
        buildFiltersPayload () {
            const payload = {}

            if (this.filters.isViewed !== null) {
                payload.isViewed = this.filters.isViewed
            }

            if (this.filters.isFavorite !== null) {
                payload.isFavorite = this.filters.isFavorite
            }

            if (this.filters.isUsed !== null) {
                payload.isUsed = this.filters.isUsed
            }

            return payload
        },
        matchesActiveFilters (video) {
            if (!video) return false

            const { isFavorite, isUsed } = this.filters
            const isViewed = this.filters.isViewed

            const viewed = video.isViewed === true

            if (isViewed !== null && viewed !== isViewed) {
                return false
            }

            if (isFavorite !== null && video.isFavorite !== isFavorite) {
                return false
            }

            if (isUsed !== null && video.isUsed !== isUsed) {
                return false
            }

            return true
        },
        async loadVideos () {
            const requestId = ++this.loadingRequestId
            try {
                const payload = this.buildFiltersPayload()
                const response = await this.getUgcVideos(Object.keys(payload).length ? payload : undefined)
                if (requestId !== this.loadingRequestId) return

                this.videos = Array.isArray(response) ? response : []
            } catch (err) {
                console.error('Erro ao carregar vídeos:', err)
                if (requestId === this.loadingRequestId) {
                    this.videos = []
                }
            }
        },
        async updateVideoFlag (video, key) {
            if (!video || !video._id || !key) return

            const index = this.videos.findIndex(v => v._id === video._id)
            if (index === -1) return

            const original = this.videos[index]
            const updated = { ...original, [key]: !original[key] }

            // atualiza otimisticamente a lista local para refletir o estado imediatamente
            this.$set(this.videos, index, updated)

            if (this.selectedVideo && this.selectedVideo._id === video._id) {
                this.selectedVideo = { ...this.selectedVideo, [key]: updated[key] }
            }

            try {
                const response = await this.updateUgcVideo({
                    _id: video._id,
                    [key]: updated[key]
                })

                // caso a API devolva dados atualizados, mescla com o registro local
                if (response && typeof response === 'object') {
                    const merged = { ...updated, ...response }

                    if (!response.event || typeof response.event !== 'object') {
                        merged.event = updated.event
                    }
                    this.$set(this.videos, index, merged)

                    if (this.selectedVideo && this.selectedVideo._id === video._id) {
                        this.selectedVideo = {
                            ...this.selectedVideo,
                            ...response,
                            event: merged.event
                        }
                    }
                }

                if (!this.matchesActiveFilters(this.videos[index])) {
                    this.videos.splice(index, 1)

                    if (this.selectedVideo && this.selectedVideo._id === video._id) {
                        this.dialog = false
                        this.selectedVideo = null
                    }
                }
            } catch (err) {
                // reverte a alteração local em caso de erro
                this.$set(this.videos, index, original)

                if (this.selectedVideo && this.selectedVideo._id === video._id) {
                    this.selectedVideo = { ...original }
                }

                console.error(`Erro ao atualizar ${key}:`, err)
            }
        },
        async toggleFavorite (video) {
            await this.updateVideoFlag(video, 'isFavorite')
        },
        async toggleUsed (video) {
            await this.updateVideoFlag(video, 'isUsed')
        },
        normalizeGiftValue () {
            const raw = (this.giftValue || '').trim()
            console.log('raw', raw)
            if (!raw) return null

            const sanitized = raw
                .replace(/\./g, '')
                .replace(',', '.')
                .replace(/[^0-9.]/g, '')

            if (!sanitized) return null

            const numeric = Number(sanitized)
            if (Number.isNaN(numeric)) return null

            if (Number.isInteger(numeric)) {
                return String(Math.trunc(numeric))
            }

            return numeric.toFixed(2)
        },
        formatVideoDate (video) {
            const value = video?.createdAt || video?.created_at
            if (!value) return '—'

            const date = new Date(value)
            if (Number.isNaN(date.getTime())) return '—'

            return new Intl.DateTimeFormat('pt-BR', {
                dateStyle: 'short',
                timeStyle: 'short'
            }).format(date)
        },
        formatGiftValue (video) {
            const value = video?.bonusValue
            if (value === undefined || value === null || value === '') return '—'

            const numeric = Number(value)
            if (!Number.isFinite(numeric)) {
                return String(value)
            }

            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(numeric)
        },
        shouldHighlightVideo (video) {
            return !(video && video.isViewed === true)
        },
        shouldHighlightEvent (item) {
            if (!item || !Array.isArray(item.videos)) return false
            return item.videos.some(video => this.shouldHighlightVideo(video))
        },
        async markVideoAsViewed (video) {
            if (!video || !video._id || video.isViewed === true) return

            const index = this.videos.findIndex(v => v._id === video._id)
            if (index === -1) return

            const original = this.videos[index]
            const updated = { ...original, isViewed: true }

            this.$set(this.videos, index, updated)

            if (this.selectedVideo && this.selectedVideo._id === video._id) {
                this.selectedVideo = { ...this.selectedVideo, isViewed: true }
            }

            try {
                await this.updateUgcVideoSilent({
                    _id: video._id,
                    isViewed: true
                })

                if (!this.matchesActiveFilters(updated)) {
                    this.videos.splice(index, 1)
                }
            } catch (err) {
                this.$set(this.videos, index, original)

                if (this.selectedVideo && this.selectedVideo._id === video._id) {
                    this.selectedVideo = { ...original }
                }

                console.error('Erro ao marcar vídeo como visualizado:', err)
            }
        },
        askCancelGift (event) {
            if (!event || !event._id) return

            this.giftToCancel = event
            this.cancelGiftDialog = true
        },
        resetCancelGiftState () {
            this.cancelGiftDialog = false
            this.giftToCancel = null
        },
        applyGiftState (eventId, hasGift, bonusValue = null) {
            if (!eventId) return

            this.videos.forEach((video, index) => {
                const currentEventId = video?.event?._id
                if (currentEventId !== eventId) return

                const updated = {
                    ...video,
                    hasBonusGift: hasGift,
                    bonusValue: hasGift ? bonusValue : null
                }
                this.$set(this.videos, index, updated)

                if (this.selectedVideo && this.selectedVideo._id === video._id) {
                    this.selectedVideo = {
                        ...this.selectedVideo,
                        hasBonusGift: hasGift,
                        bonusValue: updated.bonusValue
                    }
                }
            })
        },
        async confirmCancelGift () {
            if (!this.giftToCancel || !this.giftToCancel._id) return

            const eventId = this.giftToCancel._id

            try {
                await this.deleteGiftVideo({ event: eventId })
                this.applyGiftState(eventId, false)
                this.resetCancelGiftState()
            } catch (err) {
                console.error('Erro ao cancelar presente:', err)
            }
        },
        openVideo (video) {
            if (!video) return
            this.selectedVideo = video
            this.dialog = true
            this.markVideoAsViewed(video)
        },
        async giftVideo(video){
            if (video) {
                this.selectedVideo = video
            }
            if (!this.selectedVideo) return
            this.giftDialog = true
        },

        onCancel () {
            this.giftDialog = false
            this.$nextTick(() => {
            this.giftValue = ''
            this.giftConfirm = false
            this.isValid = false
            })
        },
        async onSubmit () {
            const ok = await this.$refs.form.validate()
            if (!ok) return
            try {
                const eventId = this.selectedVideo?.event?._id

                if (!eventId) throw new Error('Evento não encontrado para presentear')

                const normalizedValue = this.normalizeGiftValue()

                if (normalizedValue === null) throw new Error('Valor do presente inválido')

                const response = await this.postGiftVideo({
                    event: eventId,
                    value: normalizedValue
                })

                const bonusValue = response?.bonusValue ?? response?.value ?? normalizedValue

                this.applyGiftState(eventId, true, bonusValue)

                this.giftDialog = false
                this.dialog = false
                this.$nextTick(() => {
                    this.giftValue = ''
                    this.giftConfirm = false
                    this.selectedVideo = null
                })

            } catch (err) {
                console.error('Erro ao enviar presente:', err)
            }
        },

        async downloadVideo () {
            if (!this.selectedVideo) return

            try {
                // baixa o arquivo como blob
                const response = await fetch(this.selectedVideo.url, { mode: 'cors' })
                if (!response.ok) throw new Error(`Erro no download: ${response.status}`)

                const blob = await response.blob()
                const url = URL.createObjectURL(blob)

                // cria link temporário
                const link = document.createElement('a')
                link.href = url
                link.download = this.selectedVideo.url.split('/').pop()   // nome do arquivo
                document.body.appendChild(link)
                link.click()

                // limpa recursos
                document.body.removeChild(link)
                URL.revokeObjectURL(url)
            } catch (err) {
                console.error(err)
            }
        }
    },
    async mounted() {
        try {
            await this.loadVideos()
        } catch (err) {
            console.error(err)
        }
    },
    watch: {
        filters: {
            deep: true,
            handler () {
                this.loadVideos()
            }
        },
        dialog (val) {
            if (!val) {
                const player = this.$refs.player
                if (player) {
                    player.pause()
                    player.currentTime = 0
                }
                this.selectedVideo = null
            }
        }
    },

}

</script>
